<template>
    <div>
        <table :class="classObj" class="invoices-table show-on-print">
        <caption class="invoices-table__title">{{title}}</caption>
            <template v-if="list.length">
                <thead>
                    <tr class="no-hover">
                        <th><b>№ п/п</b></th>
                        <th><b>№ решения</b></th>
                        <th><b>Дата</b></th>
                        <th><b>Название банка</b></th>
                        <template v-if="inModal">
                            <th><b>БИК банка, в который направлено решение</b></th>
                            <th><b>Код налогового органа</b></th>
                            <th><b>Дата и время размещения информации в сервисе ФНС</b></th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(e, i) in list" :key="i">
                        <td class="grey-cell">{{i + 1}}</td>
                        <td>{{e.number ? e.number : '-'}}</td>
                        <td>{{e.date_resolution ? dateParser(e.date_resolution) : '-'}}</td>
                        <td>{{e.bank_name ? e.bank_name : '-'}}</td>
                        <template v-if="inModal">
                            <td>{{e.bik ? e.bik : '-'}}</td>
                            <td v-if="e.code_ifns"><span class="ifns-title" :title="e.inspection_name">{{e.code_ifns}}</span></td>
                            <td v-else>-</td>
                            <td>{{e.date_post ? e.date_post : '-' | parseToTimeDate}}</td>
                        </template>
                    </tr>
                </tbody>
            </template>
            <tr class="no-hover empty-invoices" v-if="!list.length && !archived">
                <td>Решения отсутствуют</td>
            </tr>
        </table>
    </div>
</template>

<script>
import { dateParser } from '@/helpers.ts'

export default {
    props: {
        list: Array,
        actualDate: String,
        archived: {
            type: Boolean,
            default: false
        },
        inModal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        title() {
            if(this.$props.archived) {
                return `Архивные решения ${this.$props.actualDate ? `на ${dateParser(this.$props.actualDate)}` : ''}`
            } else {
                return `Актуальные решения ${this.$props.actualDate ? `на ${dateParser(this.$props.actualDate)}` : ''}`
            }
        },
        classObj() {
            return {
                archive: this.$props.archived,
                'in_modal': this.$props.inModal
            }
        }
    },
    filters: {
        parseToTimeDate(date) {
            if(date === '-') {
                return date
            } else {
                return date.split(' ').map((e, i) => i === 0 ? dateParser(e) : e).join(' ')
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.invoices-table
    @include lic-table
    tr
        td, th
            font-size: 13px
            text-align: left
            line-height: 18px
            vertical-align: top
            padding: 5px 8px
            color: #111
        th
            white-space: nowrap
            font-weight: 700
        td
            font-weight: 500
    tr.no-hover
        &:hover
            background: none
    &__title
        margin: 0
        font-size: 16px
        font-weight: 600
        border-bottom: solid 1px
        line-height: 18px
        color: #111
        text-align: left
    .ifns-title
        cursor: help
        border-bottom: 1px dashed #aaa
    &.archive
        tr
            td, th
                color: #777
        .invoices-table__title
                color: #777
    &.in_modal
        .invoices-table__title
            font-size: 20px
        tr 
            td, th
                padding: 8px
            td
                border-bottom: 1px solid #ddd
                font-size: 16px 
    tr.empty-invoices
        td
            color: #777
            font-size: 16px
            padding: 8px

</style>